module.exports = __webpack_public_path__ + "media/images/open-menu-4aaf92d0ed86d1b1165581081977af0d.svg";